<template>
  <div class="contain">
    <div class="scene" ref="scene">
      <div class="scene-banner">
        <img src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/scene/scene-banner2.jpg">
        <div class="scene-pic-title">
          <h1 class="scene-title">{{ sceneInfo.sceneName }}</h1>
          <p class="scene-subtitle">爆品合集</p>
        </div>

        <div class="scene-list">
          <Earth :picList="sceneList" v-if="sceneList.length" />
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多场景<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu class="whole-scene" slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in sceneList"
                class=" "
                :key="index"
                :command="item.sceneId"
              >{{ item.sceneName }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="specialty-list" ref="specialty">
        <div class="item-list" :class="{'left': left}">
          <div
            class="specialty-item"
            :class="{ active: activeIndex === index }"
            v-for="(item, index) in moduleList"
            :key="index"
            @click="scrollToObj(index)"
          >
            <span>{{ item.sceneTypeName }}</span>
            <transition name="slide-fade">
              <p v-if="show" class="item-text">{{ specialtyText }}</p>
            </transition>
          </div>
        </div>
        <div class="back-top" @click="goTop">
          <img src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/scene/baktotop.png">
          <p class="back-text">返回顶部</p>
        </div>
      </div>

      <div class="cf view-box">
        <div :ref="`module${mdlI}`" v-for="(mdl, mdlI) in moduleList" :key="mdlI">
          <div class="specialty-title">{{ mdl.sceneTypeName }}</div>
          <div
            class="view"
            :ref="`viewShow${mdlI}`"
          >
            <div
              :ref="`moduleRef${mdlI}${-1}`"
              class="father"
              @mouseenter="highLight('father',mdlI)"
              @mouseleave="lowLight(mdlI)"
              :class="{ on: mdl.moduleOn == -1 }"
            >
              <div class="pic-wrap">
                <img class="vpic" :src="mdl.bgImg.imgUrl" alt="" />
                <div
                  class="all-dot"
                  @click="toShowDetail(fdot, mdlI, -1, $refs[`viewShow${mdlI}`], 'father')"
                  @mouseenter="toShowTooltip(mdlI, -1, fdot.xposition)"
                  v-for="(fdot, fdotI) in mdl.bgImg.imgPositions"
                  :key="fdotI"
                  :style="{
                    top: fdot.yposition - 14 + 'px',
                    left: fdot.xposition - 14 + 'px'
                  }"
                >
                  <i class="m-t-dot1"></i>
                  <!-- <i class="m-t-dot2"></i> -->
                  <i class="m-t-dot"></i>
                  <div class="tooltip" :class="{ l: dotLeft }">
                    {{ fdot.machineName }}
                  </div>
                </div>
              </div>
            </div>
            <div class="children">
              <div
                class="child"
                @mouseenter="enterChild($event,img,mdlI);highLight('child', mdlI, img, imgI)"
                @mouseleave="leaveChild($event,img,mdlI);lowLight(mdlI)"
                :class="{
                  on: mdl.moduleOn == imgI || img.together || img.open
                }"
                v-for="(img, imgI) in mdl.moduleImgs"
                :key="imgI"
                :ref="`moduleRef${mdlI}${imgI}`"
              >
                <img class="vpic" :src="img.imgUrl" alt="" />
                <!-- <el-tooltip
                class="m-dot"
                effect="dark"

                :content="d.name"
                placement="right"
              > -->
                <div
                  class="all-dot"
                  @click="toShowDetail(dot, mdlI, imgI, $refs[`viewShow${mdlI}`], img)"
                  @mouseenter="toShowTooltip(mdlI, imgI, dot.xposition)"
                  v-for="(dot, dotI) in img.imgPositions"
                  :key="dotI"
                  :style="{
                    top: dot.yposition - 14 + 'px',
                    left: dot.xposition - 14 + 'px'
                  }"
                >
                  <i class="m-t-dot1"></i>
                  <!-- <i class="m-t-dot2"></i> -->
                  <i class="m-t-dot"></i>
                  <div class="tooltip" :class="{ l: dotLeft }">
                    {{ dot.machineName }}
                  </div>
                </div>
              </div>
            </div>
            <div class="dialog-wrap">
              <div
                class="dialog"
                ref="dotDialog"
                :class="{
                  right: mdl.ifRight,
                  left: mdl.ifLeft,
                  bottom: mdl.ifBottom,
                  top: mdl.ifTop,
                  on: mdl.ifOn
                }"
              >
                <i class="close el-icon-close" @click="handleClose(mdlI)"></i>
                <h3 class="title">
                  {{ mdl.detail.thirdCategory }}
                  <span>—— {{ mdl.detail.forthCategory }}</span>
                </h3>
                <div class="cate categorys">
                  <span class="unit">产品</span>
                  <ul class="list">
                    <li
                      :class="{ on: cateI == mdl.detail.cateOn }"
                      @click="toSelectCate(cate.poolId, mdlI, cateI)"
                      v-for="(cate, cateI) in mdl.detail.categorys"
                      :key="cateI"
                    >
                      {{ cate.poolName }}
                    </li>
                  </ul>
                </div>
                <div class="cate brands">
                  <span class="unit">品牌</span>
                  <ul class="list">
                    <li
                      :class="{ off: brand.brandId === selectBrandId }"
                      v-for="(brand, brandI) in mdl.detail.brands"
                      :key="brandI"
                      @click="toList('brand', mdlI, brand.brandId)"
                    >
                      <img :src="brand.brandLogo" alt="" />
                    </li>
                  </ul>
                </div>
                <div class="action">
                  <el-button
                    type="danger"
                    size="small"
                    @click="toList('confirm', mdlI)"
                    >确认</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import debounce from 'lodash/debounce'
import { isElementInViewport } from '@/utils'
import earth from './earth.vue'
export default {
  components: {
    Earth: earth
  },
  data () {
    return {
      detail: {
        thirdCategory: '',
        forthCategory: '',
        brands: [],
        categorys: []
      },
      // moduleOn: -2,
      // ifRight: false,
      // ifLeft: false,
      // ifOn: false,
      cateOn: -1,
      cateOnList: [],
      dotLeft: false,

      sceneInfo: {},
      moduleList: [],
      debounceFun: null,
      debounceFun2: null,
      sceneList: [], // 场景列表
      activeIndex: 0,
      show: false, // 左侧悬浮延展出的字条显示隐藏
      selectBrandId: '',
      specialtyText: '',
      left: false
    }
  },
  async mounted () {
    this.getSceneList()
    await this.getData()
    // window.scrollTo(0, 1)
    this.debounceFun = this.inVisibleLeft
    this.debounceFun2 = this.fixLeft
    window.addEventListener('resize', this.debounceFun)
    document.addEventListener('scroll', this.debounceFun2)
  },
  destroyed () {
    this.debounceFun && window.removeEventListener('resize', this.debounceFun)
    this.debounceFun2 && document.removeEventListener('scroll', this.debounceFun2)
  },
  methods: {
    clickHighLight (img, index, imgIndex) {
      const type = img === 'father' ? 'father' : 'child'
      this.lowLight(index, false)
      const viewThis = document.querySelectorAll('.view')[index]
      if (type === 'father') {
        viewThis.querySelector('.father').classList.remove('grey-filter')
        Array.from(viewThis.querySelectorAll('.child')).forEach((item) => {
          item.classList.add('grey-filter')
        })
      }
      if (type === 'child') {
        // 先把背景加上暗光
        viewThis.querySelector('.father').classList.add('grey-filter')
        // 判断child有无分组再加上暗光
        const IMGS = this.moduleList[index].moduleImgs
        const SIGN = img.groupName
        if (img.groupName !== '') {
          IMGS.forEach((imgItem, iIndex) => {
            if (imgItem.groupName !== SIGN) {
              // 有分组情况就下，不是当前分组的child加上暗光
              Array.from(viewThis.querySelectorAll('.child')).forEach((item, index) => {
                if (index === iIndex) {
                  item.classList.add('grey-filter')
                }
              })
            }
          })
        } else {
          // 没有分组的情况下除了当前的imgIndex其他都加上暗光
          Array.from(viewThis.querySelectorAll('.child')).forEach((item, index) => {
            if (index !== imgIndex) {
              item.classList.add('grey-filter')
            }
          })
        }
      }
    },
    highLight (role, index, img, imgIndex) {
      const lightOn = this.moduleList[index].moduleOn
      if (lightOn !== -2) return
      const viewThis = document.querySelectorAll('.view')[index]
      if (role === 'father') {
        viewThis.querySelector('.father').classList.remove('grey-filter')
        Array.from(viewThis.querySelectorAll('.child')).forEach((item) => {
          item.classList.add('grey-filter')
        })
      }
      if (role === 'child') {
        // 先把背景加上暗光
        viewThis.querySelector('.father').classList.add('grey-filter')
        // 判断child有无分组再加上暗光
        const IMGS = this.moduleList[index].moduleImgs
        const SIGN = img.groupName
        if (img.groupName !== '') {
          IMGS.forEach((imgItem, iIndex) => {
            if (imgItem.groupName !== SIGN) {
              // 有分组情况就下，不是当前分组的child加上暗光
              Array.from(viewThis.querySelectorAll('.child')).forEach((item, index) => {
                if (index === iIndex) {
                  item.classList.add('grey-filter')
                }
              })
            }
          })
        } else {
          // 没有分组的情况下除了当前的imgIndex其他都加上暗光
          Array.from(viewThis.querySelectorAll('.child')).forEach((item, index) => {
            if (index !== imgIndex) {
              item.classList.add('grey-filter')
            }
          })
        }
      }
    },
    // 移除所有的暗光
    lowLight (index, turnOn = true) {
      const lightOn = this.moduleList[index].moduleOn
      if (lightOn !== -2 && turnOn) return
      const viewThis = document.querySelectorAll('.view')[index]
      viewThis.querySelector('.father').classList.remove('grey-filter')
      Array.from(viewThis.querySelectorAll('.child'))
        .forEach((item) => {
          item.classList.remove('grey-filter')
        })
    },
    enterChild (e, item, index) {
      const lightOn = this.moduleList[index].moduleOn
      if (lightOn !== -2) return
      const IMGS = this.moduleList[index].moduleImgs
      const SIGN = item.groupName
      if (item.groupName !== '') {
        IMGS.forEach(img => {
          img.together = img.groupName === SIGN
        })
      }
    },
    leaveChild (e, item, index) {
      const lightOn = this.moduleList[index].moduleOn
      if (lightOn !== -2) return
      const IMGS = this.moduleList[index].moduleImgs
      if (item.groupName !== '') {
        IMGS.forEach(img => {
          img.together = false
        })
      }
    },
    // 跳转场景
    handleCommand (val) {
      this.$router.push({ name: 'Scene', query: { sceneId: val } })
    },
    // 滚动到对应专业
    scrollToObj (index) {
      // 关闭工艺的小条
      const scrollRef = this.$refs[`module${index}`] && this.$refs[`module${index}`][0]
      if (!scrollRef) return
      scrollRef.scrollIntoView({
        behavior: 'smooth'
      })
      if (this.activeIndex === index) return
      this.handleClose(this.activeIndex)
      this.show = false
      this.activeIndex = index
    },
    // 左侧悬浮js
    fixLeft () {
      const visibleIndex = this.visibleIndex()
      if (visibleIndex.length >= 1) {
        this.$nextTick(() => {
          if (this.activeIndex !== visibleIndex[0]) {
            // 查看当前有弹窗的模块序号
            const MODULE_ON_INDEX = this.moduleList.findIndex(item => item.ifOn)
            // 如果弹窗模块跟左侧悬浮序号不一样，则把工艺隐藏
            this.show = !(MODULE_ON_INDEX !== visibleIndex[0])
          }
          this.activeIndex = visibleIndex[0]
        })
      }
      if (!this.$refs.specialty) return
      this.$nextTick(() => {
        let halfWindowH = window.innerHeight / 2
        let fixHeight = this.$refs.specialty.offsetHeight
        this.$refs.specialty.style.position = 'fixed'
        this.$refs.specialty.style.top = halfWindowH - fixHeight / 2 + 'px'
      })
    },
    getOffset (obj, direction) {
      let offsetL = 0
      let offsetT = 0
      while (obj !== window.document.body && obj !== null) {
        offsetL += obj.offsetLeft
        offsetT += obj.offsetTop
        obj = obj.offsetParent
      }
      if (direction === 'left') {
        return offsetL
      } else {
        return offsetT
      }
    },
    getSceneList () {
      // 商品场景化
      this.$http.get(
        '/front/cross/commodity-user/sceneInfos'
      ).then(res => {
        let sd = res.data.data
        if (sd && sd.list) {
          this.sceneList = sd.list || []
        }
      })
    },
    toShowTooltip (mdlI, imgI, xposition) {
      let ref = this.$refs[`moduleRef${mdlI}${imgI}`]
      this.dotLeft = xposition > ref[0].clientWidth / 2
    },
    toList (from, mdlI, brandId) {
      let presentModule = this.moduleList[mdlI]

      if (from === 'brand') {
        this.selectBrandId = brandId
        return
      }
      if (from === 'confirm' && !presentModule.detail.selectPoolId) {
        this.$message.warning('请选择您想了解的产品')
        return
      }
      let routeUrl = this.$router.resolve({
        name: 'SceneList',
        query: {
          machineId: presentModule.detail.machineId,
          poolId: presentModule.detail.selectPoolId,
          brandId: this.selectBrandId,
          sceneId: this.$route.query.sceneId
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    async getData () {
      // this.$http
      //   .get('/front/commodity-scene/manager/editSceneGetCopy/' + this.$route.query.sceneId)
      //   .then(({ data: res }) => {
      //     if (res.code === 0) this.sceneInfo = res.data
      //   })
      this.$http
        .get('/front/cross/commodity-user/sceneInfo/itemDetails', { params: { sceneId: this.$route.query.sceneId } })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.sceneInfo = {
              sceneName: res.data.sceneName
            }
            let r = res.data.itemDetails
            r.forEach((v) => {
              v.ifLeft = false
              v.ifRight = false
              v.ifBottom = false
              v.ifTop = false
              v.ifOn = false
              v.moduleOn = -2
              v.detail = {
                thirdCategory: '',
                forthCategory: '',
                brands: [],
                categorys: [],
                cateOn: -1,
                selectPoolId: '',
                machineId: '',
                presentFrom: ''
              }
              v.bgImg = v.sceneImgs.find((g) => g.isBackground)
              v.moduleImgs = v.sceneImgs.filter((g) => !g.isBackground).map(item => {
                return {
                  ...item,
                  together: false,
                  open: false
                }
              })
            })
            this.moduleList = r

            this.$nextTick(() => {
              // 判断屏幕大小，固定在内容区域还是旁边留白区域
              this.inVisibleLeft()
              // 固定初始位置
              this.fixLeft()
            })
          }
        })
    },
    // 判断fixedleft悬浮窗有没有靠边
    inVisibleLeft () {
      let fixWidth = this.$refs.specialty.offsetWidth
      const clientRect = this.$refs.scene.getBoundingClientRect()
      if (clientRect.left < fixWidth) {
        this.$refs.specialty.style.left = clientRect.left + 'px'
        this.left = false
        return
      }
      this.left = true
      this.$refs.specialty.style.left = clientRect.left - fixWidth + 'px'
    },
    toShowBox (presentModule, fromX, fromY, viewRef, viewIndex) {
      if (fromX + fromY !== presentModule.presentFrom) {
        presentModule.ifOn = false
        presentModule.ifRight = false
        presentModule.ifLeft = false
        presentModule.ifTop = false
        presentModule.ifBottom = false
      }
      presentModule.presentFrom = fromX + fromY

      setTimeout(() => {
        // 重置topleft值
        const clientRect = viewRef[0].getBoundingClientRect()
        if (fromX === 'r') {
          presentModule.ifRight = true
        }
        if (fromX === 'l') {
          presentModule.ifLeft = true
        }
        if (fromY === 't') {
          presentModule.ifTop = true
          // 判断弹窗是不是在视窗顶部外
          this.$refs.dotDialog[viewIndex].style.bottom = ''
          if (clientRect.top < -20) {
            this.$refs.dotDialog[viewIndex].style.top = -clientRect.top + 20 + 'px'
          }
        }
        if (fromY === 'b') {
          presentModule.ifBottom = true
          // 判断弹窗是不是在视窗底部外
          const bottom = (clientRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 20)
          const offBottom = clientRect.bottom - (window.innerHeight || document.documentElement.clientHeight) + 20
          this.$refs.dotDialog[viewIndex].style.top = ''
          if (!bottom) {
            this.$refs.dotDialog[viewIndex].style.bottom = offBottom + 'px'
          }
        }
      })

      setTimeout(() => {
        presentModule.ifOn = true
      }, 100)
    },
    getBrands (poolId, presentModule) {
      this.$http
        .get(`/front/cross/commodity-user/scenePools/${poolId}/brands`)
        .then((res) => {
          presentModule.detail.brands = res.data.data.brands
        })
    },
    toSelectCate (poolId, mdlI, cateI) {
      let presentModule = this.moduleList[mdlI]
      presentModule.detail.cateOn = cateI
      presentModule.detail.selectPoolId = poolId
      this.getBrands(poolId, presentModule)
      // this.cateOnList = cate.brands;
    },
    toShowDetail (dot, mdlI, imgI, viewRef, item) {
      this.moduleList.forEach((module, i) => {
        if (mdlI !== i) this.handleClose(i)
      })

      // 打开分组一起显示
      if (item) {
        const IMGS = this.moduleList[mdlI].moduleImgs
        const SIGN = item.groupName
        if (item.groupName !== '') {
          IMGS.forEach(img => {
            img.open = img.groupName === SIGN
          })
        } else {
          IMGS.forEach(img => {
            img.open = false
          })
        }
      }
      let presentModule = this.moduleList[mdlI]
      presentModule.moduleOn = imgI
      presentModule.detail.machineId = dot.machineId

      let containWdith = viewRef[0].clientWidth
      let containHeight = viewRef[0].clientHeight
      this.toShowBox(
        presentModule,
        dot.xposition < containWdith / 2 ? 'r' : 'l',
        dot.yposition < containHeight / 2 ? 't' : 'b',
        viewRef,
        mdlI
      )

      this.$http
        .get(
          `/front/cross/commodity-user/scenePools?machineId=${dot.machineId}`
        )
        .then((res) => {
          presentModule.detail.categorys = res.data.data.scenePools
        })

      presentModule.detail.thirdCategory = dot.craftName
      presentModule.detail.forthCategory = dot.machineName
      presentModule.detail.brands = []
      // this.detail.categorys = cate;
      presentModule.detail.cateOn = -1
      presentModule.detail.cateOnList = []

      // 清空所选择的专业
      this.selectBrandId = ''

      // 左侧出现使用的工艺
      this.show = false
      this.$nextTick(() => {
        this.specialtyText = dot.craftName
        this.show = true
      })

      this.activeIndex = mdlI
      // 点击的地方高亮
      this.$nextTick(() => {
        this.clickHighLight(item, mdlI, imgI)
      })
    },
    handleClose (mdlI) {
      // 取消分组一起显示的开关
      const IMGS = this.moduleList[mdlI].moduleImgs
      IMGS.forEach(img => {
        img.open = false
        img.together = false
      })
      // 取消分组一起显示的开关 end
      this.show = false
      let presentModule = this.moduleList[mdlI]
      presentModule.moduleOn = -2
      presentModule.ifOn = false
      this.lowLight(mdlI, false)
      setTimeout(() => {
        presentModule.ifLeft = false
        presentModule.ifRight = false
        presentModule.ifBottom = false
        presentModule.ifTop = false
      }, 300)
    },
    // 返回视窗内的序号
    visibleIndex () {
      let jumpArr = []
      Array.from(document.querySelectorAll('.specialty-title')).forEach((item, index) => {
        isElementInViewport(item) && jumpArr.push(index)
      })
      return jumpArr
    },
    // 返回顶部
    goTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style lang="scss">
.whole-scene {
  .el-dropdown-menu__item{
    color: #3D88D4;
    // text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.grey-filter {
  filter: brightness(0.7);
  @media screen and(-ms-high-contrast:active),(-ms-high-contrast:none){
    &::before {
      background: rgba(0, 0, 0, .3)!important;
    }
    &.father::before {
      z-index: 1;
      pointer-events: none;
      transition: none;
    }
    &.child {
      z-index: 1;
    }
    &.child::before {
      transition: none;
    }
  }
}
.item-list {
  &.left {
    .specialty-item {
      opacity: 1;
    }
  }
}

@keyframes dot1Opacity {
  0% {
    opacity: 0.6;
  }

  100% {
    opacity: 0.1;
  }
}

@keyframes dot2Opacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.5;
  }
}
.contain {
  // padding-top: 20px;
  margin: 0 auto;
  width: 1200px;
  background: #fff;
  .scene {
    position: relative;
    .scene-banner {
      position: relative;
      font-size: 0;
      width: 1190px;
      margin: 0 auto;
      @media (max-width: 1200px) {
        width: 1200px;
      }
      .scene-pic-title {
        position: absolute;
        left: 55px;
        top: 48%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);

        .scene-title {
          font-size: 27px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #A7DEFF;
          line-height: 38px;
          margin: 0 0 2px;
        }

        .scene-subtitle {
          font-size: 27px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 38px;
          margin: 0;
        }
      }
    }
    .specialty-list {
      position: absolute;
      top: 212px;
      left: 0;
      z-index: 11;
      -webkit-user-select: none;
      user-select: none;
      transition: top 0s ease-in-out, opacity .3s ease-in-out;
      // position: fixed;
      // top: 50%!important;
      // transform: translateY(-50%);
      // -webkit-transform: translateY(-50%);

      .item-list {
        box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.29);
        display: flex;
        flex-direction: column;
        text-align: center;
        cursor: pointer;
        width: 52px;
      }

      .specialty-item {
        position: relative;

        span {
          display: block;
          background: #fff;
          color: #3D88D4;
          padding: 6px 12px;
          line-height: 20px;
          font-size: 14px;
          font-weight: 500;
          position: relative;
          z-index: 2;
          transition: all .3s ease-in-out;
          word-break: break-word;
        }

        .item-text {
          display: none;
        }

        &.active {
          span {
            background: #3D88D4;
            color: #fff;
          }

          .item-text {
            display: flex;
            align-items: center;
            margin: 0;
            left: 100%;
            position: absolute;
            z-index: 1;
            background: #fff;
            color: #3D88D4;
            min-width: 100%;
            padding: 0 12px;
            white-space: nowrap;
            box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.29);
            height: 36px;
            top: 50%;
            margin-top: -18px;
            line-height: 36px;
          }
        }

        .slide-fade-enter-active {
          transition: all 0.3s ease;
        }
        .slide-fade-leave-active {
          transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
        }
        .slide-fade-enter, .slide-fade-leave-to {
          transform: translateX(-100px);
          opacity: 0;
        }
      }

      .back-top {
        height: 52px;
        width: 52px;
        background: #fff;
        display: flex;
        margin: 13px auto 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.1);

        img {
          width: 32px;
          height: 32px;
        }

        .back-text {
          display: none;
          margin-top: 6px;
          margin-bottom: 0;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #3D88D4;
          line-height: 20px;
        }
      }
    }
    .scene-list {
      text-align: right;
      padding-right: 24px;
      position: absolute;
      right: 0;
      top: 44px;

      .earth-container {
        display: inline-block;
        margin-right: 44px;
      }

      .el-dropdown {
        width: 110px;
        height: 44px;
        background: rgba(61, 139, 211, 0.05);
        line-height: 44px;
        text-align: center;
        box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        border: 1px solid #FFFFFF;
      }

      .el-dropdown-link {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
      }
    }
    .view-box {
      // width: 1200px;
      .specialty-title {
        text-align: center;
        margin:0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        line-height: 40px;
        height: 40px;
        background: #3D8BD3;
        margin-top: 32px;
      }
      .view {
        position: relative;
        // overflow: hidden;
        .father {
          position: relative;
          cursor: pointer;
          transition: all 0.3s;
          text-align: center;
          .pic-wrap {
            display: inline-block;
            position: relative;
          }
          &::before {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0);
            content: '';
            left: 0;
            top: 0;
            -webkit-user-select: none;
            user-select: none;
            transition: all 0.3s;
          }
          &.on,
          &:hover {
            img {
              box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.29);
            }
            &::before {
              background-color: rgba(255, 255, 255, 0);
            }
            .all-dot {
              display: block;
            }
          }
        }
        .children {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          overflow: hidden;
          pointer-events: none;
          .child {
            position: relative;
            cursor: pointer;
            display: inline-block;
            transition: all 0.3s;
            pointer-events: all;
            &::before {
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: rgba(255, 255, 255, 0);
              content: '';
              left: 0;
              top: 0;
              -webkit-user-select: none;
              user-select: none;
              transition: all 0.3s;
            }
            &.on,
            &:hover {
              z-index: 7;
              box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.29);
              &::before {
                background-color: rgba(255, 255, 255, 0);
              }
              .all-dot {
                display: block;
              }
            }
            // &:hover {
            //   z-index: 8;
            // }
          }
        }
        .all-dot {
          width: 28px;
          height: 28px;
          position: absolute;
          cursor: pointer;
          // display: none;
          .m-t-dot1 {
            width: 28px;
            height: 28px;
            display: block;
            background-color: #3d8bd3;
            position: absolute;
            border-radius: 50%;
            left: 0px;
            top: 0px;
            z-index: 1;
            opacity: 0.6;
            animation: dot1Opacity 0.8s 0.4s infinite;
          }

          .m-t-dot2 {
            width: 20px;
            height: 20px;
            display: block;
            background-color: #3d8bd3;
            position: absolute;
            border-radius: 50%;
            left: 4px;
            top: 4px;
            z-index: 2;
            animation: dot2Opacity 0.8s infinite;
          }

          .m-t-dot {
            width: 14px;
            height: 14px;
            display: block;
            background-color: #3d8bd3;
            position: absolute;
            border-radius: 50%;
            left: 7px;
            top: 7px;
            z-index: 3;
          }
          .tooltip {
            white-space: nowrap;
            position: absolute;
            left: 33px;
            top: 50%;
            height: 28px;
            background: #ffffff;
            border-radius: 14px;
            text-align: center;
            padding: 0 12px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 28px;
            opacity: 0;
            transition: all 0.3s;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
            transform: translate(10px, -50%);
            &.l {
              left: auto;
              right: 33px;
              transform: translate(-10px, -50%);
            }
          }
          &:hover {
            .tooltip {
              opacity: 1;
              transform: translate(0, -50%);
            }
          }
        }
        .dialog-wrap {
          overflow: hidden;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
        }
        .dialog {
          width: 400px;
          position: absolute;
          min-height: 400px;
          right: -440px;
          top: 20px;
          z-index: 10;
          background-color: #fff;
          box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.29);
          // border-radius: 10px;
        }

        .dialog.right {
          right: -440px;
          transition: right 0.3s;
        }

        .dialog.right.on {
          pointer-events: all;
          right: 20px;
        }

        .dialog.left {
          left: -440px;
          right: auto;
          transition: left 0.3s;
        }

        .dialog.left.on {
          pointer-events: all;
          left: 20px;
        }
        .dialog.bottom {
          bottom: 20px;
          top: auto;
        }

        .dialog.top {
          top: 20px;
        }

        .dialog .title {
          padding: 0 20px;
          margin-bottom: 28px;
          margin-top: 16px;
          font-size: 16px;
        }

        .dialog .title span {
          // color: #3d88d4;
          font-size: 14px;
          font-weight: 400;
        }

        .dialog .cate {
          display: flex;
          flex-direction: row;
          padding: 0 20px;
          margin-bottom: 14px;
        }

        .dialog .cate .unit {
          line-height: 20px;
          width: 50px;
          font-weight: bold;
          flex-shrink: 0;
          font-size: 12px;
        }

        .dialog .cate .list {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          flex-grow: 1;
          overflow: hidden;
          font-size: 12px;
        }

        .dialog .cate .list li {
          height: 20px;
          background-color: #fff;
          color: #3d88d4;
          // border-radius: 3px;
          // border: 1px solid #cbcbcb;
          border: 1px solid #3d88d4;
          display: inline-block;
          line-height: 18px;
          padding: 0 16px;
          margin-right: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          -webkit-user-select: none;
          user-select: none;
        }

        .dialog .categorys .list li.on {
          color: #fff;
          border-color: #3d88d4;
          background-color: #3d88d4;
        }

        .dialog .brands .list li.off {
          color: #c3c3c3;
          border-color: #3d88d4;
          cursor: auto;
        }

        .dialog .brands .list li {
          border-color: #cbcbcb;
          height: auto;
          padding: 0;
          img {
            height: 38px;
          }
        }

        .dialog .action {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px;
        }

        .el-button--danger {
          color: #fff;
          background-color: #3d88d4;
          border-color: #3d88d4;
          width: 100px;
        }

        .el-button--danger:focus,
        .el-button--danger:hover {
          background: #58a2ec;
          border-color: #58a2ec;
          color: #fff;
        }

        .dialog .close {
          position: absolute;
          font-size: 30px;
          color: #999;
          right: 10px;
          top: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
